

const SearchInput = ({
  search,
  onSearchChange,
  onSearchClick,
  onCloseClick,
  handleKeyDown,
  showClose,
}) => {
  return (
    <div className="relative">
      <input
        type="search"
        className="block w-[425px] h-9 px-4 py-2 text-sm rounded-[5px] border table_border title_color"
        placeholder="Search by Name or Contact..."
        value={search}
        onChange={onSearchChange}
        onKeyDown={handleKeyDown}
        aria-label="Search by Name or Contact"
        required
      />

      <button
        type="button"
        aria-label={showClose ? "Clear search" : "Search"}
        className="w-6 h-6 blue_bg rounded-full inline-flex items-center justify-center absolute top-1/2 -translate-y-1/2 right-2"
        onClick={showClose ? onCloseClick : onSearchClick}
      >
        {showClose ? (
         
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M1 1L12 12" stroke="white" strokeWidth="2" />
              <path d="M12 1L1 12" stroke="white" strokeWidth="2" />
            </svg>
       
        ) : (
         
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10.4202 9.71315C10.225 9.51789 9.9084 9.51788 9.71313 9.71314C9.51787 9.9084 9.51787 10.225 9.71313 10.4203L10.4202 9.71315ZM11.8464 12.5536C12.0417 12.7488 12.3582 12.7488 12.5535 12.5536C12.7488 12.3583 12.7488 12.0417 12.5535 11.8464L11.8464 12.5536ZM4.9277 3.12667C5.20044 3.08347 5.38652 2.82735 5.34333 2.55461C5.30013 2.28187 5.04401 2.09578 4.77126 2.13898L4.9277 3.12667ZM2.13897 4.77128C2.09577 5.04402 2.28185 5.30015 2.55459 5.34334C2.82733 5.38654 3.08346 5.20046 3.12665 4.92772L2.13897 4.77128ZM9.71313 10.4203L11.8464 12.5536L12.5535 11.8464L10.4202 9.71315L9.71313 10.4203ZM5.79999 10.1C3.42517 10.1 1.5 8.17481 1.5 5.79999H0.5C0.5 8.7271 2.87289 11.1 5.79999 11.1V10.1ZM10.1 5.79999C10.1 8.17481 8.17481 10.1 5.79999 10.1V11.1C8.72709 11.1 11.1 8.7271 11.1 5.79999H10.1ZM5.79999 1.5C8.17481 1.5 10.1 3.42517 10.1 5.79999H11.1C11.1 2.87289 8.72709 0.5 5.79999 0.5V1.5ZM5.79999 0.5C2.87289 0.5 0.5 2.87289 0.5 5.79999H1.5C1.5 3.42517 3.42517 1.5 5.79999 1.5V0.5ZM4.77126 2.13898C3.41627 2.35359 2.35357 3.41629 2.13897 4.77128L3.12665 4.92772C3.27349 4.00062 4.0006 3.27351 4.9277 3.12667L4.77126 2.13898Z"
                fill="white"
              />
            </svg>
        
        )}
      </button>
    </div>
  );
};

export default SearchInput;
